import React, { ChangeEvent, ReactNode } from 'react'
import styled from 'styled-components'
import AnimatedLoader from '../AnimatedLoader'
// import AnimatedLoader from '@/components/UI/Animation/AnimatedLoader'
// import { Progress } from 'antd'

const StyledPureImageUploadButton = styled.button`
  position: absolute;
  height: 48px;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.semantics.zap.surface.primary};
  cursor: pointer;
  outline: none;
  font-style: normal;
  font-weight: 700;
  transition: background-color 0.4s;
  background: ${({ theme }) => theme.semantics.zap.surface.primary};
  border: 2px solid #efefef;
  border-radius: 4px;
  box-shadow: 0px 12px 13px -6px rgba(0, 0, 0, 0.04);
`

export function SelectUploadButton({ label }: { label?: string }) {
  return (
    <StyledPureImageUploadButton>
      <img src={'/upload.svg'} alt="button icon" />
      {label}
    </StyledPureImageUploadButton>
  )
}

const ImageUploadButtonCont = styled.div`
  align-self: center;
  max-width: 50%;
  overflow: hidden;
`

const ImageUploadLoader = styled.div<{ progress?: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 36px;
  height: 36px;

  .loading-holder {
    position: absolute;
  }

  .ant-progress-text {
    display: none;
  }
`

function UploadButton({
  input,
  isLoading,
  progress,
  button,
}: {
  input: ReactNode
  isLoading?: boolean
  progress?: number
  button?: React.ReactNode
}) {
  return (
    <ImageUploadButtonCont>
      {isLoading ? (
        <ImageUploadLoader>
          <AnimatedLoader size={26} onlyWhite />
          {/* {!!progress && (
            <Progress
              type="circle"
              size={50}
              percent={progress}
              strokeColor={{
                '0%': '#F4ED0D',
                '50%': '#CA41E2',
                '100%': '#3F5DFF',
              }}
            />
          )} */}
        </ImageUploadLoader>
      ) : (
        button ?? <SelectUploadButton />
      )}

      {input}
    </ImageUploadButtonCont>
  )
}

// export function ImageUploadButton({
//   onImageChange,
//   isLoading,
//   progress,
//   button,
// }: {
//   onImageChange: (e: ChangeEvent<HTMLInputElement>) => void
//   isLoading?: boolean
//   progress?: number
//   button?: React.ReactNode
// }) {
//   return (
//     <UploadButton
//       input={<input type="file" accept="image/*" onChange={onImageChange} />}
//       isLoading={isLoading}
//       progress={progress}
//       button={button}
//     />
//   )
// }

export function VideoUploadButton({
  onVideoChange,
  isLoading,
  progress,
  button,
}: {
  onVideoChange: (e: ChangeEvent<HTMLInputElement>) => void
  isLoading?: boolean
  progress?: number
  button?: React.ReactNode
}) {
  return (
    <UploadButton
      input={
        <input type="file" accept="video/*,image/*" onChange={onVideoChange} />
      }
      isLoading={isLoading}
      progress={progress}
      button={button}
    />
  )
}
